/** @type {import('../help-index.js').HelpSidebarItem} */
export const FIN_CHR_MANAGEMENT_ITEM = {
  id: 'checks_sidebar_1',
  screenId: 'fin-chr-management',
  label: 'Gestión',
  description: 'Cheques recibidos de clientes y su destino.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Controlás los cheques de terceros que recibiste como cobro: los que están en cartera, depositados, endosados, cobrados por ventanilla o rechazados.',
      },
      {
        title: 'De dónde salen los cheques',
        paragraphs: [
          'Los cheques nuevos se cargan al registrar un cobro (Finanzas → Cobros) con medio «cheque de tercero»: elegís cartera, número, fechas, datos del emisor y observaciones.',
          'Para endosar un cheque a un proveedor no usás esta pantalla: andá a Pagos y elegí un cheque que ya esté en cartera como medio de pago.',
        ],
      },
      {
        title: 'Paso 1 — Filtros y búsqueda',
        intro: 'Al entrar ves los cheques en cartera. Podés refinar la búsqueda con:',
        fields: [
          { label: 'Fechas de emisión / de pago', description: 'Rango desde–hasta para cada tipo de fecha.' },
          { label: 'Estado', description: 'Por ejemplo en cartera, depositado, endosado, pagado, rechazado, etc. También «Todos».' },
          { label: 'Cartera de cheques', description: 'Solo aparece si el estado es «En cartera». Filtrá por una cartera o dejá «Todas».' },
          { label: 'Más filtros', description: 'Número de cheque y cliente (buscador por nombre).' },
        ],
        paragraphs: ['Tocá «Buscar» para aplicar los filtros. Podés exportar la grilla.'],
      },
      {
        title: 'Paso 2 — Leer la lista',
        bullets: [
          'Columnas habituales: Número, Monto, Cliente, Cartera, Fecha emisión, Fecha pago, Observaciones.',
          'Si buscás por estado distinto de «solo en cartera», también ves la columna Estado.',
          'Tocá una fila para ver el detalle completo del cheque.',
        ],
      },
      {
        title: 'Paso 3 — Acciones sobre un cheque',
        intro: 'Desde el menú de acciones de cada fila:',
        bullets: [
          'Depositar — elegís cuenta bancaria y fecha de depósito. El cheque pasa a depositado.',
          'Endosar — el sistema te indica que debés ir a Pagos para crear el pago con ese cheque.',
          'Cobrar por ventanilla — registrás el cobro en efectivo en una caja autorizada, con fecha.',
          'Rechazado — fecha y motivo de rechazo (lista del sistema).',
          'Mover a cartera — elegís otra cartera. Si el cheque estaba endosado, se revierte el endoso y el pago asociado.',
          'Custodiar — indicás en qué cuenta bancaria queda custodiado (sin fecha de depósito).',
          'Eliminar — solo cuando corresponda según permisos y estado del cheque.',
        ],
      },
    ],
  },
}
